import { render, staticRenderFns } from "./ihaleDetay.vue?vue&type=template&id=70869890&"
import script from "./ihaleDetay.vue?vue&type=script&lang=js&"
export * from "./ihaleDetay.vue?vue&type=script&lang=js&"
import style0 from "./ihaleDetay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports